import { useHistory } from "react-router";
import { HiArrowLeft } from "react-icons/hi";

function BackButton({ to }) {
  const history = useHistory();
  const handleBack = () => {
    if (to) {
      history.push(to);
    } else {
      history.goBack();
    }
  };
  return (
    <button
      type="button"
      onClick={handleBack}
      className="inline-flex items-center justify-center gap-1.5 sm:gap-2 px-3 py-2.5 sm:px-5 sm:py-2 min-h-[44px] sm:min-h-[40px] rounded-md text-white font-medium text-sm sm:text-base bg-amber-700 hover:bg-amber-800 active:bg-amber-900 border border-amber-800/50 shadow-sm mt-2 sm:mt-1 mb-1 sm:mb-2 touch-manipulation transition-colors"
    >
      <HiArrowLeft className="text-base sm:text-lg flex-shrink-0" aria-hidden />
      <span>Back</span>
    </button>
  );
}

export default BackButton;
